// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3sLRp","colCheckbox":"styles_colCheckbox__2gSuE"};